import CnpjUtils from "../../../shared/utils/CnpjUtils";
import MonetaryUtils from "../../../shared/utils/MonetaryUtils";


export const apuracaoFilterConfig = [
	{
		section: "Meta de Net Sales",
		fields: [
			{
				name: "netSalesGoalReached",
				label: "Atingiu",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			},
			{
				name: "netSalesGoalNotReached",
				label: "Não atingiu",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			}
		]
	},
	{
		section: "Meta de Varilux",
		fields: [
			{
				name: "variluxGoalReachedOrNotApplicable",
				label: "Atingiu/não se aplica",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			},
			{
				name: "variluxGoalNotReached",
				label: "Não atingiu",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			}
		]
	},
	{
		section: "Meta do Grupo",
		fields: [
			{
				name: "groupGoalReachedOrNotApplicable",
				label: "Atingiu/não se aplica",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			},
			{
				name: "groupGoalNotReached",
				label: "Não atingiu",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			}
		]
	},
	{
		section: "Inadimplente",
		fields: [
			{
				name: "latePaymentYes",
				label: "Sim",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			},
			{
				name: "latePaymentNo",
				label: "Não",
				type: "checkbox",
				defaultValue: false,
				columns: 12
			}
		]
	},
	{
		section: "Nome do equipamento",
		fields: [
			{
				name: "equipmentName",
				label: "",
				type: "text",
				placeholder: "Ex: EQUIP 01",
				defaultValue: "",
				columns: 12
			}
		]
	},
	{
		section: "Valor do equipamento",
		fields: [
			{
				name: "equipmentValue",
				label: "",
				type: "rangeBetween",
				fromPlaceholder: "R$ 0,00",
				toPlaceholder: "R$ 0,00",
				defaultValue: {
					from: "",
					to: ""
				},
				onChange: value => MonetaryUtils.formatCurrency(value, { fromCents: true }),
				columns: 12
			}
		]
	},
	{
		section: "Desconto concedido (%)",
		fields: [
			{
				name: "grantedDiscountPercentage",
				label: "",
				type: "rangeBetween",
				fromPlaceholder: "50%",
				toPlaceholder: "80%",
				defaultValue: {
					from: "",
					to: ""
				},
				columns: 12
			}
		]
	},
	{
		section: "CNPJ do cliente",
		fields: [
			{
				name: "clientDocument",
				label: "",
				type: "text",
				placeholder: "00.000.000/0001-00",
				defaultValue: "",
				mask: CnpjUtils.getAlphanumericCnpjMask(),
				guide: false,
				columns: 12
			}
		]
	},
	{
		section: "Tamanho do cliente",
		fields: [
			{
				name: "clientSize",
				label: "",
				type: "select",
				placeholder: "Todos",
				defaultValue: "",
				options: [],
				columns: 12
			}
		]
	},

];